var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTickInCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 98,
    height: 98,
    rx: 49,
    stroke: "#E3B05F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.122 50.292a1 1 0 10-1.414 1.415L44.132 62.13l.024.025a.999.999 0 001.444-.03l20.869-20.869a1 1 0 10-1.414-1.414L44.863 60.034l-9.741-9.742z",
    fill: "#E3B05F"
  })));
}

export default SvgTickInCircle;